
import React, { useState, useEffect } from "react";
import {
  Home,
  Users,
  Star,
  FileText,
  CreditCard,
  Settings,
  Building2,
  MapPin,
  Phone,
  Mail,
  Camera,
  Calendar,
  TrendingUp,
  IndianRupee,
  Eye,
  Bell,
  Menu,
  X,
  Upload,
  Plus,
  Edit3,
  Save,
  Trash2,
  CheckCircle,
  AlertCircle,
  Clock,
  Globe,
  Shield,
  Award,
  Search,
  Navigation,
  Loader2,
  Image as ImageIcon,
  VideoIcon,
  LogOut,
} from "lucide-react";

import { toast } from "react-hot-toast";
import api from "../../utils/axios";
import { useAuth } from "../../store/hooks/useRedux";

const DocumentsSection = ({ vendorData, onUpdate }) => {
    console.log('Vendor Data: DocumentsSection', vendorData);
    const [uploadingDoc, setUploadingDoc] = useState("");
  
    const documentTypes = {
      businessLicense: "Business License",
      gstLicense: "GST Certificate",
      identityProof: "Identity Proof",
      bankProof: "Bank Proof",
      fssaiCertificate: "FSSAI Certificate",
      liquorLicense: "Liquor License",
    };
  
    const handleDocumentUpload = async (files, docType) => {
      try {
        setUploadingDoc(docType);
        const formData = new FormData();
        formData.append("files", files[0]);
  
        const response = await api.post("/image/upload", formData);
  
        if (response.data.success) {
          const updateData = {
            documents: {
              ...vendorData.vendor.documents,
              [docType]: response.data.data.files[0].url,
            },
          };
  
          await api.put("/vendors/profile/update", updateData);
          toast.success("Document uploaded successfully");
          onUpdate();
        }
      } catch (error) {
        toast.error("Failed to upload document");
      } finally {
        setUploadingDoc("");
      }
    };
  
    return (
      <div className="space-y-6">
        <div className="bg-white rounded-2xl border border-gray-200/70 shadow-[0_1px_3px_rgba(16,24,40,0.04)] p-6">
          <h2 className="font-['Manrope'] text-xl font-bold tracking-tight text-gray-900 mb-6">
            Business Documents
          </h2>
  
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {Object.entries(documentTypes).map(([key, label]) => (
              <div key={key} className="border border-gray-200 rounded-lg p-4">
                <div className="flex items-center justify-between mb-3">
                  <span className="font-medium text-gray-900">{label}</span>
                  {vendorData?.vendor?.documents?.[key] && (
                    <CheckCircle className="w-5 h-5 text-green-500" />
                  )}
                </div>
  
                <label className="flex items-center space-x-2 bg-purple-50 text-purple-700 px-4 py-2 rounded-lg cursor-pointer hover:bg-purple-100 transition-colors">
                  {uploadingDoc === key ? (
                    <Loader2 className="w-4 h-4 animate-spin" />
                  ) : (
                    <Upload className="w-4 h-4" />
                  )}
                  <span>
                    {vendorData?.documents?.[key] ? "Replace" : "Upload"}
                  </span>
                  <input
                    type="file"
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                    onChange={(e) => handleDocumentUpload(e.target.files, key)}
                    className="hidden"
                  />
                </label>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

    export default DocumentsSection;